/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * LiftAI API
 * LiftAI elevator/lift asset-management REST API.
 * OpenAPI spec version: 1.0.0 (v1)
 */
import * as zod from 'zod';


export const CompliancesListQueryParams = zod.object({
  "ahj_id": zod.string().optional().describe('AHJ ID'),
  "date_issued_after": zod.string().date().optional().describe('Date Issued'),
  "date_issued_before": zod.string().date().optional().describe('Date Issued'),
  "examination_date_after": zod.string().date().optional().describe('Examination Date'),
  "examination_date_before": zod.string().date().optional().describe('Examination Date'),
  "expiration_date_after": zod.string().date().optional().describe('Expiration Date'),
  "expiration_date_before": zod.string().date().optional().describe('Expiration Date'),
  "expires_after": zod.string().date().optional().describe('Expires'),
  "expires_before": zod.string().date().optional().describe('Expires'),
  "has_closed_violations": zod.boolean().optional().describe('Has Closed Violations'),
  "has_open_violations": zod.boolean().optional().describe('Has Open Violations'),
  "has_stale_violations": zod.boolean().optional().describe('Has Stale Violations'),
  "inspection_status": zod.enum(['failed', 'no_certificate', 'passed', 'pending']).optional().describe('Inspection Status\n\n\* `no_certificate` - No Certificate\n\* `failed` - Failed\n\* `passed` - Passed\n\* `pending` - Pending'),
  "jurisdiction": zod.string().optional().describe('Jurisdiction'),
  "last_cat1_test_after": zod.string().date().optional().describe('Last CAT-1 Test'),
  "last_cat1_test_before": zod.string().date().optional().describe('Last CAT-1 Test'),
  "last_cat5_test_after": zod.string().date().optional().describe('Last CAT-5 Test'),
  "last_cat5_test_before": zod.string().date().optional().describe('Last CAT-5 Test'),
  "limit": zod.number().optional().describe('Number of results to return per page.'),
  "next_inspection_due_after": zod.string().date().optional().describe('Next Examination Due'),
  "next_inspection_due_before": zod.string().date().optional().describe('Next Examination Due'),
  "next_violation_due_after": zod.string().date().optional().describe('Next Violation Due'),
  "next_violation_due_before": zod.string().date().optional().describe('Next Violation Due'),
  "offset": zod.number().optional().describe('The initial index from which to return the results.'),
  "ordering": zod.array(zod.enum(['-ahj_id', '-examination_date', '-expiration_date', '-has_closed_violations', '-has_open_violations', '-inspection_status', '-jurisdiction', '-last_cat1_test', '-last_cat5_test', '-next_inspection_due', '-next_violation_due', '-portfolio_name', '-property_name', '-service_provider_name', '-unit_name', '-violations_without_updates', 'ahj_id', 'examination_date', 'expiration_date', 'has_closed_violations', 'has_open_violations', 'inspection_status', 'jurisdiction', 'last_cat1_test', 'last_cat5_test', 'next_inspection_due', 'next_violation_due', 'portfolio_name', 'property_name', 'service_provider_name', 'unit_name', 'violations_without_updates'])).optional().describe('Ordering\n\n\* `unit_name` - Unit name\n\* `-unit_name` - Unit name (descending)\n\* `portfolio_name` - Portfolio name\n\* `-portfolio_name` - Portfolio name (descending)\n\* `ahj_id` - Ahj id\n\* `-ahj_id` - Ahj id (descending)\n\* `property_name` - Property name\n\* `-property_name` - Property name (descending)\n\* `service_provider_name` - Service provider name\n\* `-service_provider_name` - Service provider name (descending)\n\* `jurisdiction` - Jurisdiction\n\* `-jurisdiction` - Jurisdiction (descending)\n\* `expiration_date` - Expiration date\n\* `-expiration_date` - Expiration date (descending)\n\* `next_inspection_due` - Next inspection due\n\* `-next_inspection_due` - Next inspection due (descending)\n\* `examination_date` - Examination date\n\* `-examination_date` - Examination date (descending)\n\* `inspection_status` - Inspection status\n\* `-inspection_status` - Inspection status (descending)\n\* `has_open_violations` - Has open violations\n\* `-has_open_violations` - Has open violations (descending)\n\* `has_closed_violations` - Has closed violations\n\* `-has_closed_violations` - Has closed violations (descending)\n\* `next_violation_due` - Next violation due\n\* `-next_violation_due` - Next violation due (descending)\n\* `violations_without_updates` - Violations without updates\n\* `-violations_without_updates` - Violations without updates (descending)\n\* `last_cat1_test` - Last cat1 test\n\* `-last_cat1_test` - Last cat1 test (descending)\n\* `last_cat5_test` - Last cat5 test\n\* `-last_cat5_test` - Last cat5 test (descending)'),
  "portfolio": zod.array(zod.string().uuid()).optional().describe('Portfolio'),
  "property": zod.string().uuid().optional().describe('Property'),
  "region": zod.array(zod.string().nullable()).optional().describe('Region'),
  "search": zod.string().optional().describe('Search'),
  "service_provider": zod.array(zod.string().uuid()).optional().describe('Service Provider'),
  "stale_violations_count": zod.number().optional().describe('Stale Violations Count'),
  "status": zod.enum(['active', 'expired', 'expiring_soon']).optional().describe('Status\n\n\* `active` - Active\n\* `expired` - Expired\n\* `expiring_soon` - Expiring Soon'),
  "unit_name": zod.string().optional().describe('Unit Name')
})

export const CompliancesListResponse = zod.object({
  "count": zod.number().optional(),
  "next": zod.string().url().nullish(),
  "previous": zod.string().url().nullish(),
  "metadata": zod.object({
  "activeCertificates": zod.number(),
  "expiringCertificates": zod.number(),
  "expiredCertificates": zod.number(),
  "certificatesByJurisdiction": zod.record(zod.string(), zod.number()),
  "certificatesWithViolations": zod.number(),
  "examinationsDueSoon": zod.number(),
  "overdueExaminations": zod.number(),
  "openDefectsTotal": zod.number(),
  "openADefectsTotal": zod.number(),
  "defectsClosedRecent": zod.number()
}).strict(),
  "results": zod.array(zod.object({
  "carId": zod.string().uuid(),
  "ahjId": zod.string(),
  "certificateId": zod.string().nullable(),
  "unitName": zod.string(),
  "portfolio": zod.string().nullable(),
  "property": zod.string().nullable(),
  "propertyId": zod.string().uuid(),
  "propertyManager": zod.record(zod.string(), zod.unknown()).nullable(),
  "serviceProviderId": zod.string().uuid().nullable(),
  "jurisdiction": zod.string().nullable(),
  "inspectionStatus": zod.enum(['passed', 'expired', '-']).describe('\* `passed` - passed\n\* `expired` - expired\n\* `-` - -'),
  "certificateExpiration": zod.string().date().nullable(),
  "openViolations": zod.number(),
  "closedViolations": zod.number(),
  "nextViolationDue": zod.string().date().nullable(),
  "violationsWithoutUpdates": zod.number(),
  "defectsDueSoon": zod.number(),
  "downloadUrl": zod.string().nullable(),
  "lastCat1Test": zod.string().date().nullable(),
  "lastCat5Test": zod.string().date().nullable(),
  "elevatorType": zod.union([zod.enum(['Traction', 'Hydro', 'Other', 'escalator', 'hydraulic-passenger', 'hydraulic-service', 'mrl-traction', 'geared-passenger', 'geared-traction', 'gearless-traction', 'gearless-passenger', 'wheelchair-lift', 'dumbwaiter', 'passenger-service', 'high-rise-passenger', 'low-rise-passenger', 'passenger', 'freight']).describe('\* `Traction` - Traction\n\* `Hydro` - Hydro\n\* `Other` - Other\n\* `escalator` - Escalator\n\* `hydraulic-passenger` - Hydraulic Passenger\n\* `hydraulic-service` - Hydraulic Service\n\* `mrl-traction` - MRL Traction\n\* `geared-passenger` - Geared Passenger\n\* `geared-traction` - Geared Traction\n\* `gearless-traction` - Gearless Traction\n\* `gearless-passenger` - Gearless Passenger\n\* `wheelchair-lift` - Wheelchair Lift\n\* `dumbwaiter` - Dumbwaiter\n\* `passenger-service` - Passenger\/Service\n\* `high-rise-passenger` - High Rise Passenger\n\* `low-rise-passenger` - Low Rise Passenger\n\* `passenger` - Passenger\n\* `freight` - Freight'),zod.enum(['']),zod.literal(null)]).nullable(),
  "lolerCode": zod.string().nullish(),
  "reportNumber": zod.string().nullish(),
  "nextInspectionDue": zod.string().date().nullish(),
  "examinationDate": zod.string().date().nullish()
}).strict())
}).strict()

export const CompliancesRetrieveParams = zod.object({
  "id": zod.string().uuid().describe('A UUID string identifying this car.')
})

export const CompliancesRetrieveResponse = zod.object({
  "carId": zod.string().uuid(),
  "ahjId": zod.string(),
  "certificateId": zod.string().nullable(),
  "unitName": zod.string(),
  "portfolio": zod.string().nullable(),
  "property": zod.string().nullable(),
  "propertyId": zod.string().uuid(),
  "propertyManager": zod.record(zod.string(), zod.unknown()).nullable(),
  "serviceProviderId": zod.string().uuid().nullable(),
  "jurisdiction": zod.string().nullable(),
  "inspectionStatus": zod.enum(['passed', 'expired', '-']).describe('\* `passed` - passed\n\* `expired` - expired\n\* `-` - -'),
  "certificateExpiration": zod.string().date().nullable(),
  "openViolations": zod.number(),
  "closedViolations": zod.number(),
  "nextViolationDue": zod.string().date().nullable(),
  "violationsWithoutUpdates": zod.number(),
  "defectsDueSoon": zod.number(),
  "downloadUrl": zod.string().nullable(),
  "lastCat1Test": zod.string().date().nullable(),
  "lastCat5Test": zod.string().date().nullable(),
  "elevatorType": zod.union([zod.enum(['Traction', 'Hydro', 'Other', 'escalator', 'hydraulic-passenger', 'hydraulic-service', 'mrl-traction', 'geared-passenger', 'geared-traction', 'gearless-traction', 'gearless-passenger', 'wheelchair-lift', 'dumbwaiter', 'passenger-service', 'high-rise-passenger', 'low-rise-passenger', 'passenger', 'freight']).describe('\* `Traction` - Traction\n\* `Hydro` - Hydro\n\* `Other` - Other\n\* `escalator` - Escalator\n\* `hydraulic-passenger` - Hydraulic Passenger\n\* `hydraulic-service` - Hydraulic Service\n\* `mrl-traction` - MRL Traction\n\* `geared-passenger` - Geared Passenger\n\* `geared-traction` - Geared Traction\n\* `gearless-traction` - Gearless Traction\n\* `gearless-passenger` - Gearless Passenger\n\* `wheelchair-lift` - Wheelchair Lift\n\* `dumbwaiter` - Dumbwaiter\n\* `passenger-service` - Passenger\/Service\n\* `high-rise-passenger` - High Rise Passenger\n\* `low-rise-passenger` - Low Rise Passenger\n\* `passenger` - Passenger\n\* `freight` - Freight'),zod.enum(['']),zod.literal(null)]).nullable(),
  "lolerCode": zod.string().nullish(),
  "reportNumber": zod.string().nullish(),
  "nextInspectionDue": zod.string().date().nullish(),
  "examinationDate": zod.string().date().nullish()
}).strict()

/**
 * Aggregated defect analytics over the same scoped, filtered lifts the compliance list returns: a 12-month opened/closed series, open defects by category, and open defects due in the next 90 days.
 */
export const CompliancesDefectAnalyticsRetrieveQueryParams = zod.object({
  "ahj_id": zod.string().optional().describe('AHJ ID'),
  "date_issued_after": zod.string().date().optional().describe('Date Issued (after)'),
  "date_issued_before": zod.string().date().optional().describe('Date Issued (before)'),
  "examination_date_after": zod.string().date().optional().describe('Examination Date (after)'),
  "examination_date_before": zod.string().date().optional().describe('Examination Date (before)'),
  "expiration_date_after": zod.string().date().optional().describe('Expiration Date (after)'),
  "expiration_date_before": zod.string().date().optional().describe('Expiration Date (before)'),
  "expires_after": zod.string().date().optional().describe('Expires (after)'),
  "expires_before": zod.string().date().optional().describe('Expires (before)'),
  "has_closed_violations": zod.boolean().optional().describe('Has Closed Violations'),
  "has_open_violations": zod.boolean().optional().describe('Has Open Violations'),
  "has_stale_violations": zod.boolean().optional().describe('Has Stale Violations'),
  "inspection_status": zod.enum(['failed', 'no_certificate', 'passed', 'pending']).optional().describe('Inspection Status'),
  "jurisdiction": zod.string().optional().describe('Jurisdiction'),
  "last_cat1_test_after": zod.string().date().optional().describe('Last CAT-1 Test (after)'),
  "last_cat1_test_before": zod.string().date().optional().describe('Last CAT-1 Test (before)'),
  "last_cat5_test_after": zod.string().date().optional().describe('Last CAT-5 Test (after)'),
  "last_cat5_test_before": zod.string().date().optional().describe('Last CAT-5 Test (before)'),
  "next_inspection_due_after": zod.string().date().optional().describe('Next Examination Due (after)'),
  "next_inspection_due_before": zod.string().date().optional().describe('Next Examination Due (before)'),
  "next_violation_due_after": zod.string().date().optional().describe('Next Violation Due (after)'),
  "next_violation_due_before": zod.string().date().optional().describe('Next Violation Due (before)'),
  "portfolio": zod.array(zod.string().uuid()).optional().describe('Portfolio'),
  "property": zod.string().uuid().optional().describe('Property'),
  "region": zod.array(zod.string()).optional().describe('Region'),
  "search": zod.string().optional().describe('Search'),
  "service_provider": zod.array(zod.string().uuid()).optional().describe('Service Provider'),
  "stale_violations_count": zod.number().optional().describe('Stale Violations Count'),
  "status": zod.enum(['active', 'expired', 'expiring_soon']).optional().describe('Status'),
  "unit_name": zod.string().optional().describe('Unit Name')
})

export const CompliancesDefectAnalyticsRetrieveResponse = zod.object({
  "openVsClosed": zod.array(zod.object({
  "month": zod.string().date(),
  "opened": zod.number(),
  "closed": zod.number()
}).strict().describe('One month of the open-vs-closed series.')),
  "openBySeverity": zod.object({
  "categoryA": zod.number(),
  "categoryB": zod.number(),
  "categoryC": zod.number(),
  "uncategorized": zod.number(),
  "total": zod.number()
}).strict().describe('Open defects split by LOLER category.'),
  "upcomingDue": zod.array(zod.object({
  "bucket": zod.enum(['days0To14', 'days15To45', 'days46To90']).describe('\* `days0To14` - days0To14\n\* `days15To45` - days15To45\n\* `days46To90` - days46To90'),
  "startDay": zod.number(),
  "endDay": zod.number(),
  "count": zod.number()
}).strict().describe('One bucket of the upcoming-due histogram.'))
}).strict().describe('The three defect-analytics panels, served as one payload.')

